/**
 * The values the employee forms offer, and the one helper that shapes what they send.
 *
 * <p>Separate from the field components so that editing a label does not force a full reload
 * of every form using them, and so the wizard and the profile dialogs cannot drift into
 * offering different spellings of the same enum.
 */

export interface Choice {
  value: string
  label: string
}

/** What the API accepts, written the way somebody would say it. */
export const GENDERS = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'OTHER', label: 'Other' },
  { value: 'UNDISCLOSED', label: 'Prefer not to say' },
] as const

export const EMPLOYMENT_TYPES = [
  { value: 'FULL_TIME', label: 'Full time' },
  { value: 'PART_TIME', label: 'Part time' },
  { value: 'CONTRACT', label: 'Contract' },
  { value: 'INTERN', label: 'Intern' },
  { value: 'CONSULTANT', label: 'Consultant' },
] as const

/** Strips the blanks a form produces so an untouched field is absent, not an empty string. */
export function pruned(draft: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(draft).filter(([, value]) => value !== '' && value !== undefined),
  )
}
